import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Transaction } from '@apis'
import { totalEarnings } from '@assets/icons'
import Table from '@components/table'
import UserProfile from '@components/userprofile'

const PlatformEarning = () => {
  const {
    items: transactions = [],
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.transaction)
  const [page, setPage] = useState(1)
  const fetchTransactions = async () => {
    await Transaction.list({
      state: 'transaction',
      params: { page, limit: 20, withUser: true },
    })
  }

  const columns = [
    {
      title: 'Booking Id',
      key: 'bookingId',
      render: (item) => item?.booking?.id,
    },
    {
      title: 'Provider Details',
      key: 'providerDetails',
      render: (item) => <UserProfile item={item.user} />,
    },
    {
      title: 'Vehicle Details',
      key: 'vehicleDetails',
      render: (item) => (
        <>
          <p>{item?.booking?.schedule?.vehicle?.name}</p>
          <p>{item?.booking?.schedule?.vehicle?.number}</p>
        </>
      ),
    },
    {
      title: 'Travel Route',
      key: 'travelRoute',
      render: (item) => (
        <>
          <p>{item?.booking?.schedule?.route?.departure?.name}</p>
          <p>{item?.booking?.schedule?.route?.destination?.name}</p>
        </>
      ),
    },
    {
      title: 'Travel Date',
      key: 'travelDate',
      render: (item) => <>{item?.booking?.data}</>,
    },
    {
      title: 'Total Earning',
      key: 'totalEarning',
      render: (item) => <>Rs {item?.amount}</>,
    },
    {
      title: 'Platform Charge',
      key: 'platformCharge',
      render: (item) => <>Rs {item?.platformCharge}</>,
    },
    {
      title: 'Vendors Pay',
      key: 'vendorsPay',
      render: (item) => <>Rs {item.amount - item.platformCharge}</>,
    },
  ]
  useEffect(() => {
    fetchTransactions().then(() => {})
  }, [page])
  return (
    <Table
      text="Platform Charge"
      icon={totalEarnings}
      columns={columns}
      data={transactions}
      totalItems={totalItems}
      totalPages={totalPages}
      loading={loading}
      pageControlled={page}
      itemsPerPage={20}
      onPageChange={setPage}
    />
  )
}

export default PlatformEarning

// import React from 'react'
//
// const index = () => {
//   return <div>fdf</div>
// }
//
// export default index
